import { ModelBase } from 'store/model-base';

export class CmsStatementList extends ModelBase {
    public static storeName: string = 'cmsStatementList';

    public breadcrumbLabel: string;
    public header: string;
    public billingCycle: string;
    public viewMoreButton: string;
    public caretIcon: CmsMediaImage;
    public subHeader: string;
    public description: string;
}
